/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Download_DetectedInputs */

const en_cad_download_detected = /** @type {(inputs: Cad_Download_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detected for your computer`)
};

/**
* | output |
* | --- |
* | "Detected for your computer" |
*
* @param {Cad_Download_DetectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_download_detected = /** @type {((inputs?: Cad_Download_DetectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Download_DetectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_download_detected(inputs)
});
export { cad_download_detected as "cad.download.detected" }